import type React from 'react';
import { useLocation } from 'react-router-dom';
import { ENABLE_ASSISTANT } from '../../constants/feature-flags';
import { Assistant } from '../assistant';
import { Navbar } from '../navbar';

const ROUTES_WITHOUT_NAVBAR = ['/form-print', '/form/new'];

interface PageShellProps {
  children: React.ReactNode;
}

export const PageShell = ({ children }: PageShellProps) => {
  const { pathname, search } = useLocation();
  const isFormPreview =
    pathname === '/form' && new URLSearchParams(search).get('mode') === 'preview';
  const hideNavbar =
    ROUTES_WITHOUT_NAVBAR.some((route) => pathname.startsWith(route)) || isFormPreview;

  return (
    <div className="flex flex-col h-screen">
      {!hideNavbar && (
        <div className="min-w-fit">
          <Navbar />
        </div>
      )}
      <div className="flex-1 min-h-0 overflow-y-auto w-full">{children}</div>
      {ENABLE_ASSISTANT && !hideNavbar && <Assistant />}
    </div>
  );
};
